enum SUBMIT_ACTIONS {
    SAVE = "save",
    DELETE = "delete",
}

export { SUBMIT_ACTIONS }